import Grid from './../Support/Grid'

/**
 * World class
 *      - contains and updates all objects
 */
export default class {
    constructor (game) {
        this.game = game
        this._objects = []
        this.grid = new Grid(this._width, this._height)
    }

    add (object) {
        object.addTo(this)
        this._objects.push(object)
        this.grid.add(object)
        return this
    }

    findObjects (location, radius) {
        let objects = this.grid.findInBox({
            x1: location.getX() - radius,
            x2: location.getX() + radius,
            y1: location.getY() - radius,
            y2: location.getY() + radius,
        })
        return objects.filter(object => {
            if (object.getLocation) {
                let distance = object.getLocation().subtract(location)
                return distance.getMagnitude() < radius
            }
            return false
        })
    }

    update (currentTime) {
        this._objects.forEach((object) => {
            object.update(currentTime)
            object.checkWrap()
        })
        return this
    }
}
